import {CaosCommand, Nullable} from "../caos-def";
import {SetVariantFunc} from "../utils.variants";
import {CaosLib} from "../utils.caosdef";
import Command from "./command";
import React from "react";


interface CommandsProps {
    readonly caosLib: CaosLib;
    readonly setVariant: SetVariantFunc;
    readonly commands: CaosCommand[]
    readonly useSeaMonkeys: boolean;
    readonly pushPopupItem: (kind: string, id: number) => void;
    readonly validCommandIds: Nullable<number[]>;
}

function sort(a: CaosCommand, b: CaosCommand): number {
    return a.command.toLowerCase().localeCompare(b.command.toLowerCase())
}

export default function CommandsElement(
    {
        caosLib,
        commands,
        setVariant,
        useSeaMonkeys,
        pushPopupItem,
        validCommandIds,
    }: CommandsProps
) {


    commands = commands.sort(sort);

    const commandsElements = commands.length > 0
        ? commands.map(makeCommandElement)
        : null;


    function makeCommandElement(command: CaosCommand): React.JSX.Element {
        const key = `command-${command.id}-${command.command}`;
        return <Command
            key={key}
            idKey={key}
            command={command}
            setVariant={setVariant}
            caosLib={caosLib}
            show={validCommandIds != null ? (validCommandIds.indexOf(command.id) >= 0) : null}
            useSeaMonkeys={useSeaMonkeys}
            pushPopupItem={pushPopupItem}
        />
    }


    return <section data-section="commands">
        <h2>Commands</h2>
        {
            commandsElements
                ? commandsElements
                : <p className="no-matching-warning">No Matching Commands</p>
        }
    </section>;
}